import React, { useEffect, useState } from 'react';
import './ListaCategoria.css';
import baseURL from '../url';
import { FaTshirt, FaSwimmer, FaFan, FaUserAlt, FaMale, FaQuestion, FaUmbrellaBeach, FaRegSmile, FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import config from '@config';

const iconMap = {
    'Tanga': <FaUserAlt />,
    'Bikini': <FaUmbrellaBeach />,
    'Briefs': <FaMale />,
    'Tank top': <FaTshirt />,
    'T-Shirt': <FaTshirt />,
    'Swimwear': <FaSwimmer />,
    'Shorts': <FaRegSmile />,
    'Abanicos': <FaFan />,
};

const ListaCategoria = ({ isCompact = false, currentCategoryId = null, logo, backgroundCatalog }) => {
    const [categorias, setCategoras] = useState([]);
    const [loading, setLoading] = useState(true);
    const [storeName, setStoreName] = useState('');
    const navigate = useNavigate();

    // LEER LA BANDERA (Por defecto true si no existe, para mantener estilo clásico)
    const homeClassic = config.HomeCategory?.homeClassic ?? true;
    const showAllProductsButton = config.Catalog?.showAllProductsButton ?? true;
    const fullCatalogButtonConfig = config.Catalog?.fullCatalogButton ?? {};
    const applyMetallicTitle = fullCatalogButtonConfig.applyMetallicTitle ?? false;
    const fullCatalogButtonVars = {
        '--lc-btn-bg-start': fullCatalogButtonConfig.bgStart ?? '#ef1f1f',
        '--lc-btn-bg-end': fullCatalogButtonConfig.bgEnd ?? '#b50000',
        '--lc-btn-border': fullCatalogButtonConfig.borderColor ?? '#ff8f5a',
        '--lc-btn-text-color': fullCatalogButtonConfig.textColor ?? '#ffffff',
        '--lc-btn-icon-color': fullCatalogButtonConfig.iconColor ?? '#ffffff',
        '--lc-btn-shadow': fullCatalogButtonConfig.shadow ?? '0 8px 18px rgba(160, 0, 0, 0.28), inset 0 1px 0 rgba(255,255,255,0.28)',
        '--lc-btn-text-shadow': fullCatalogButtonConfig.textShadow ?? '0 2px 5px rgba(0, 0, 0, 0.35)',
        '--lc-btn-radius': fullCatalogButtonConfig.radius ?? '999px',
        '--lc-btn-padding': fullCatalogButtonConfig.padding ?? '14px 26px',
        '--lc-btn-font-size': fullCatalogButtonConfig.fontSize ?? '1.25rem',
        '--lc-btn-letter-spacing': fullCatalogButtonConfig.letterSpacing ?? '0.6px',
        '--lc-btn-max-width': fullCatalogButtonConfig.maxWidth ?? '460px',
    };

    useEffect(() => {
        fetch(`${baseURL}/api/categorias/con-precios`)
            .then(res => res.json())
            .then(data => {
                if (data.categorias) setCategoras(data.categorias);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error cargando categorías:', error);
                setLoading(false);
            });
        
        fetch(`${baseURL}/api/contacto`)
            .then(res => res.json())
            .then(data => {
                if (data.contacto && data.contacto.length > 0) setStoreName(data.contacto[0].nombre || '');
            });
    }, []);

    if (loading) return <div className="lc-loading">Cargando categorías...</div>;

    const containerStyle = {
        backgroundImage: `
            linear-gradient(135deg, rgba(255,255,255,0.7) 60%, color-mix(in srgb, var(--color1) 12%, #d8d8d8) 100%),
            radial-gradient(ellipse at 60% 0%, rgba(255,255,255,0.3) 0%, transparent 60%),
            url(${backgroundCatalog})
        `,
        backgroundSize: 'cover, cover, cover',
        backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
        backgroundPosition: 'center, center, center',
    };

    const renderCategoryContent = (cat) => {
        if (cat.imagen) {
            return (
                <img 
                    src={cat.imagen} 
                    alt={`Imagen de ${cat.categoria}`}
                    className="lc-category-image"
                    onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                    }}
                />
            );
        }
        return (
            <div className="lc-icon">
                {iconMap[cat.categoria] || <FaQuestion />}
            </div>
        );
    };

    // --- MODO COMPACTO (Sidebar/Widget) ---
    if (isCompact) {
        return (
            <div className="lc-container-compact" style={containerStyle}>
                <div className="lc-header-compact">
                    <h2 className="lc-title-compact">Explora otras categorías</h2>
                    <p className="lc-subtitle-compact">¿Te gustaría ver más productos?</p>
                </div>
                <div className="lc-grid-compact">
                    {categorias
                        .filter(cat => cat.idCategoria !== currentCategoryId)
                        .slice(0, 6)
                        .map((cat) => (
                            <div
                                className="lc-card-compact"
                                key={cat.categoria + cat.precio_minimo}
                                onClick={() => window.location.href = `/productos?idCategoria=${cat.idCategoria}`}
                                role="button"
                            >
                                {renderCategoryContent(cat)}
                                <div className="lc-cat-name-compact">{cat.categoria}</div>
                                <div className="lc-price-compact">
                                    <span className="lc-desde">Desde</span> ${cat.precio_minimo}
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        );
    }

    // --- MODO PRINCIPAL ---
    return (
        <div className="lc-container" style={containerStyle}>
            <div className="lc-separator"></div>
            <div className="lc-header">
                <img src={logo} alt="Logo tienda" className="lc-logo" />
                <h1 className={`lc-title ${applyMetallicTitle ? 'lc-title--torzo-metallic' : ''}`}>Categorías</h1>
            </div>
            <div className="lc-grid">
                {categorias.map((cat) => (
                    <div
                        // Si homeClassic es false, agregamos la clase 'lc-card-modern'
                        className={`lc-card ${!homeClassic ? 'lc-card-modern' : ''}`}
                        key={cat.categoria + cat.precio_minimo}
                        onClick={() => window.location.href = `/productos?idCategoria=${cat.idCategoria}`}
                        role="button"
                    >
                        {/* Contenedor de Imagen (Ahora toma todo el espacio en modo moderno) */}
                        <div className="lc-image-wrapper-full">
                            {renderCategoryContent(cat)}
                        </div>
                        
                        {/* Icono de respaldo */}
                        {cat.imagen && (
                            <div className="lc-icon" style={{ display: 'none' }}>
                                {iconMap[cat.categoria] || <FaQuestion />}
                            </div>
                        )}

                        {/* Título y Precio: SOLO se muestran si es homeClassic */}
                        {homeClassic && (
                            <>
                                <div className="lc-cat-name">{cat.categoria}</div>
                                <div className="lc-price">
                                    <span className="lc-desde">Desde</span> ${cat.precio_minimo}
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>

            {showAllProductsButton && (
                <div className="lc-footer-action" style={{ width: '100%', maxWidth: '800px', marginTop: '2rem' }}>
                    <button 
                        className={`lc-btn-full-catalog ${fullCatalogButtonConfig.variant === 'torzo-pill' ? 'lc-btn-full-catalog--torzo' : ''}`}
                        onClick={() => navigate('/productos')}
                        style={fullCatalogButtonVars}
                    >
                        {fullCatalogButtonConfig.text || 'Catálogo completo aquí'} <FaArrowRight />
                    </button>
                </div>
            )}
        </div>
    );
};

export default ListaCategoria;